import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { StrategicImperative } from '../models/strategic-imperative.model';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root',
})
export class StrategicImperativesService {
  private apiUrl = `/api/strategic-imperatives`; // Adjust if your API URL is different

  constructor(
    private http: HttpClient,
    private oidcSecurityService: OidcSecurityService
  ) {}

  getStrategicImperatives(): Observable<StrategicImperative[]> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<StrategicImperative[]>(this.apiUrl, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  createStrategicImperative(imperative: Partial<StrategicImperative>): Observable<StrategicImperative> {
    // Remove isNew property before sending to backend
    const { isNew: _isNew, ...payload } = imperative;
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.post<StrategicImperative>(this.apiUrl, payload, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  updateStrategicImperative(id: number, imperative: Partial<StrategicImperative>): Observable<StrategicImperative> {
    // Remove isNew property before sending to backend
    const { isNew: _isNew, ...payload } = imperative;
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.patch<StrategicImperative>(`${this.apiUrl}/${id}`, payload, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }
}
